var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckInCircle = function SvgIconCheckInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-check-in-circle_svg__a)",
    fill: "#F46790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25c4.825 0 8.75 3.925 8.75 8.75s-3.925 8.75-8.75 8.75S3.25 16.825 3.25 12 7.175 3.25 12 3.25ZM12 2C6.475 2 2 6.475 2 12s4.475 10 10 10 10-4.475 10-10S17.525 2 12 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09 14.808a.618.618 0 0 1-.44-.183l-2.55-2.55a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0L11.09 13.3l3.925-3.925a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-4.366 4.367a.618.618 0 0 1-.442.183Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-check-in-circle_svg__a",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.823529 0 0 0 0 0.882353 0 0 0 0 0.886275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5936_128900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5936_128900",
    result: "shape"
  })))));
};
export default SvgIconCheckInCircle;